import { useRouter } from "next/router";
import styles from "./searchbar.module.css";
import { useEffect, useState } from "react";
import searchIcon from "./../../public/search-icon-pink.png";
export default function Searchbar() {
  const router = useRouter();
  const { q } = router.query;
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    if (q != undefined) {
      setSearchValue(q as string);
    } else {
      setSearchValue("");
    }
  }, [q]);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (searchValue && searchValue.length > 1) {
      router.push(`/sok?q=${searchValue}`);
    }
  };

  return (
    <div className={styles.searchbarContainer}>
      <form onSubmit={handleSubmit} className={styles.form} role="search">
        <label htmlFor="searchField">Søk i over 10 000 produkter</label>
        <img className={styles.searchIcon} src={searchIcon.src} alt="" />
        <input
          value={searchValue}
          onChange={(e: any) => {
            setSearchValue(e.target.value);
          }}
          autoComplete="off"
          id="searchField"
          name="searchField"
          className={styles.searchbar}
          placeholder="Søk etter produkt, merke eller kategori"
          type="text"
        />
        {searchValue && (
          <button
            className={styles.clearButton}
            type="button"
            onClick={() => setSearchValue("")}
            aria-label="Tøm søkefelt"
          >
            &times;
          </button>
        )}
        <button className={styles.submitButton} type="submit" disabled={searchValue.length < 2}>
          Finn pris
        </button>
      </form>
    </div>
  );
}
